import { Injectable, Injector } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { from, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class ApiService {
  constructor(private http: HttpClient, private injector: Injector) {}

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    let authService = this.injector.get(AuthService);
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'http://localhost:4200',
      'Access-Control-Allow-Methods': 'GET',
      /* Authorization: `Bearer ${authService.getToken()}` */
    });
    return this.http
      .get(`${environment.serverUrl}${path}`, { headers, params })
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, body: Object = {}): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'http://localhost:4200',
      'Access-Control-Allow-Methods': 'PUT',
    });
    return this.http
      .put(`${environment.serverUrl}${path}`, JSON.stringify(body), { headers })
      .pipe(catchError(this.formatErrors));
  }

  putParams(path: string, params: HttpParams): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'http://localhost:4200',
      'Access-Control-Allow-Methods': 'PUT',
    });
    let postbody = {};
    return this.http
      .put(`${environment.serverUrl}${path}`, postbody, { headers, params })
      .pipe(catchError(this.formatErrors));
  }

  postFile(path: string, data: FormData): Observable<any> {
    // let headers = new HttpHeaders({ 'Content-Type': 'multipart/form-data '  });
    return this.http
      .post(`${environment.serverUrl}${path}`, data)
      .pipe(catchError(this.formatErrors));
  }

  post(path: string, body: any): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'http://localhost:4200',
      'Access-Control-Allow-Methods': 'POST',
    });
    return this.http
      .post(`${environment.serverUrl}${path}`, JSON.stringify(body), {
        headers,
      })
      .pipe(catchError(this.formatErrors));
  }

  checkContent(body: any, _contentType?: any): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key':
        'B3pVt6Z0XzJL7Uux13mqLpXt6muZ5GCIDJUDk98PvUem2BKWMePDJQQJ99CDAC8vTInXJ3w3AAAHACOGSCzW',
    });
    const fileToBase64 = (file: Blob): Promise<string> =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result as string;
          const base64 = result.includes(',') ? result.split(',')[1] : result;
          resolve(base64);
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    return from(fileToBase64(body)).pipe(
      switchMap((base64) => {
        const payload = {
          image: { content: base64 },
          categories: ['Hate', 'SelfHarm', 'Sexual', 'Violence'],
          outputType: 'FourSeverityLevels',
        };
        return this.http.post(
          `https://text-and-image-content-safety.cognitiveservices.azure.com/contentsafety/image:analyze?api-version=2023-10-01`,
          payload,
          { headers }
        );
      }),
      map((res: any) => {
        const flagged =
          !!res?.categoriesAnalysis &&
          res.categoriesAnalysis.some((c: any) => c.severity > 7);
        return { ...res, IsImageAdultClassified: flagged };
      }),
      catchError(this.formatErrors)
    );
  }

  postParams(path: string, params: HttpParams): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'http://localhost:4200',
      'Access-Control-Allow-Methods': 'POST',
    });
    let postbody = {};
    return this.http
      .post(`${environment.serverUrl}${path}`, postbody, { headers, params })
      .pipe(catchError(this.formatErrors));
  }

  delete(path: string, params: HttpParams): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'http://localhost:4200',
      'Access-Control-Allow-Methods': 'DELETE',
    });
    return this.http
      .delete(`${environment.serverUrl}${path}`, { headers, params })
      .pipe(catchError(this.formatErrors));
  }

  checkTextContent(body: string | string[]): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key':
        'B3pVt6Z0XzJL7Uux13mqLpXt6muZ5GCIDJUDk98PvUem2BKWMePDJQQJ99CDAC8vTInXJ3w3AAAHACOGSCzW',
    });
    const text = Array.isArray(body)
      ? body.filter((s) => s && s.trim().length > 0).join('\n\n')
      : body;
    const payload = {
      text: text,
      categories: ['Hate', 'Sexual', 'SelfHarm', 'Violence'],
      outputType: 'FourSeverityLevels',
    };
    return this.http
      .post(
        `https://text-and-image-content-safety.cognitiveservices.azure.com/contentsafety/text:analyze?api-version=2023-10-01`,
        payload,
        { headers }
      )
      .pipe(
        map((res: any) => {
          const flagged =
            !!res?.categoriesAnalysis &&
            res.categoriesAnalysis.some((c: any) => c.severity > 7);
          return { ...res, IsTextFlagged: flagged };
        }),
        catchError(this.formatErrors)
      );
  }
}
